
  (function(){
    function initUpsellCarousel() {
      const root = document.querySelector('[data-upsell-root]');
      if (!root) return;
      
      // 如果已经初始化过，先清理
      if (root.dataset.upsellInit) return;
      root.dataset.upsellInit = 'true';
      
      const track = root.querySelector('[data-upsell-track]');
      const viewport = root.querySelector('[data-upsell-viewport]');
      const items = Array.from(track.querySelectorAll('.upsell-item'));
      const btnPrev = root.querySelector('[data-upsell-prev]');
      const btnNext = root.querySelector('[data-upsell-next]');

      let index = 0;
      const clamp = (n,min,max)=>Math.max(min,Math.min(max,n));
      const visibleCount = () => items.filter(it => getComputedStyle(it).display !== 'none').length;

      function update(){
        const count = visibleCount();
        if (count <= 1) { btnPrev.disabled = true; btnNext.disabled = true; return; }
        track.style.transform = `translateX(-${index*100}%)`;
        btnPrev.disabled = index <= 0;
        btnNext.disabled = index >= count-1;
      }

      btnPrev.addEventListener('click', () => { index = clamp(index-1, 0, items.length-1); update(); });
      btnNext.addEventListener('click', () => { index = clamp(index+1, 0, items.length-1); update(); });

      // 初始尺寸 & 重绘
      items.forEach(it => it.style.flex = '0 0 100%');
      
      const resizeHandler = () => update();
      window.addEventListener('resize', resizeHandler);
      
      // 存储清理函数
      root._cleanupUpsell = () => {
        window.removeEventListener('resize', resizeHandler);
        delete root.dataset.upsellInit;
      };
      
      update();
    }

    // 初始化
    initUpsellCarousel();

    // 监听购物车更新事件，重新初始化轮播
    document.addEventListener('cart:refresh', () => {
      setTimeout(() => {
        const root = document.querySelector('[data-upsell-root]');
        if (root && root._cleanupUpsell) {
          root._cleanupUpsell();
        }
        initUpsellCarousel();
      }, 100);
    });

    // 也监听 DOM 变化（备用方案）
    const observer = new MutationObserver(() => {
      const root = document.querySelector('[data-upsell-root]');
      if (root && !root.dataset.upsellInit) {
        initUpsellCarousel();
      }
    });
    
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('#cart-drawer') || document.body;
    observer.observe(cartDrawer, { childList: true, subtree: true });

    // —— B 方案：拦截 upsell 变体下拉事件，避免冒泡到 cart.js —— //
    const stop = (e) => {
      if (e.target && e.target.classList && e.target.classList.contains('upsell-variant-select')) {
        e.stopPropagation();
      }
    };
    document.addEventListener('change', stop, true);
    document.addEventListener('input', stop, true);

    // 切换变体时更新按钮文字 Sold out / Add
    document.addEventListener('change', (e) => {
      if (!e.target || !e.target.classList || !e.target.classList.contains('upsell-variant-select')) return;
      const form = e.target.closest('product-form');
      const btn  = form && form.querySelector('[type="submit"]');
      const opt  = e.target.options[e.target.selectedIndex];
      if (!btn || !opt) return;
      if (opt.disabled) {
        btn.setAttribute('aria-disabled','true');
        const span = btn.querySelector('span'); if (span) span.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      } else {
        btn.removeAttribute('aria-disabled');
        const span = btn.querySelector('span'); if (span) span.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add';
      }
    }, false);
  })();
